module.exports = __webpack_public_path__ + "media/images/admin_logo-d142990a858caa3ba97c535c6daf232c.svg";